/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse403,
    InlineResponse403FromJSON,
    InlineResponse403ToJSON,
    UserLocation,
    UserLocationFromJSON,
    UserLocationToJSON,
    UserLocationDataFrame,
    UserLocationDataFrameFromJSON,
    UserLocationDataFrameToJSON,
} from '../models';

export interface ApiUserLocationsGetRequest {
    relations?: string;
    deleted?: boolean;
    filtering?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

export interface ApiUserLocationsIdDeleteRequest {
    id: number;
}

export interface ApiUserLocationsIdGetRequest {
    id: number;
    relations?: string;
    deleted?: boolean;
}

export interface ApiUserLocationsPostRequest {
    relations?: string;
    deleted?: boolean;
    userLocation?: UserLocation;
}

/**
 * no description
 */
export class UserLocationApi extends runtime.BaseAPI {

    /**
     * Get list of UserLocation
     */
    async apiUserLocationsGetRaw(requestParameters: ApiUserLocationsGetRequest): Promise<runtime.ApiResponse<UserLocationDataFrame>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        if (requestParameters.filtering !== undefined) {
            queryParameters['filtering'] = requestParameters.filtering;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/userLocations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserLocationDataFrameFromJSON(jsonValue));
    }

    /**
     * Get list of UserLocation
     */
    async apiUserLocationsGet(relations?: string, deleted?: boolean, filtering?: string, offset?: number, limit?: number, order?: string): Promise<UserLocationDataFrame> {
        const response = await this.apiUserLocationsGetRaw({ relations: relations, deleted: deleted, filtering: filtering, offset: offset, limit: limit, order: order });
        return await response.value();
    }

    /**
     * Remove entity of UserLocation
     */
    async apiUserLocationsIdDeleteRaw(requestParameters: ApiUserLocationsIdDeleteRequest): Promise<runtime.ApiResponse<UserLocation>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiUserLocationsIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/userLocations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserLocationFromJSON(jsonValue));
    }

    /**
     * Remove entity of UserLocation
     */
    async apiUserLocationsIdDelete(id: number): Promise<UserLocation> {
        const response = await this.apiUserLocationsIdDeleteRaw({ id: id });
        return await response.value();
    }

    /**
     * Get entity of UserLocation
     */
    async apiUserLocationsIdGetRaw(requestParameters: ApiUserLocationsIdGetRequest): Promise<runtime.ApiResponse<UserLocation>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiUserLocationsIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/userLocations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserLocationFromJSON(jsonValue));
    }

    /**
     * Get entity of UserLocation
     */
    async apiUserLocationsIdGet(id: number, relations?: string, deleted?: boolean): Promise<UserLocation> {
        const response = await this.apiUserLocationsIdGetRaw({ id: id, relations: relations, deleted: deleted });
        return await response.value();
    }

    /**
     * Create or update entity of UserLocation (if id defined)
     */
    async apiUserLocationsPostRaw(requestParameters: ApiUserLocationsPostRequest): Promise<runtime.ApiResponse<UserLocation>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/userLocations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserLocationToJSON(requestParameters.userLocation),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserLocationFromJSON(jsonValue));
    }

    /**
     * Create or update entity of UserLocation (if id defined)
     */
    async apiUserLocationsPost(relations?: string, deleted?: boolean, userLocation?: UserLocation): Promise<UserLocation> {
        const response = await this.apiUserLocationsPostRaw({ relations: relations, deleted: deleted, userLocation: userLocation });
        return await response.value();
    }

}
